module.exports = __webpack_public_path__ + "media/images/emoticons/bomb-4a4f0eadcfb913b71c6e9ee8813d0721.gif";